class ActivityFilterModel {
    actionName: null;
    insertDate: null;
    metrics: null;
    getResult = () => {
        return {
            actionName: this.actionName,
            insertDate: this.insertDate,
            metrics: this.metrics
        }
    }
}
export default ActivityFilterModel
